export default {
  name: 'KWave',
  props: {
    uuid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      waving: true,
    }
  },
  methods: {
    handleAfterEnter() {
      this.waving = false
      this.$emit('waveEnd', this.uuid)
    },
  },
  render() {
    return (
      <transition
        appear={true}
        name="ripple-wave"
        onAfterEnter={this.handleAfterEnter}
      >
        {
          this.waving
            ? (<div/>)
            : null
        }
      </transition>
    )
  },
}
